import styled, { css } from 'styled-components'
import { shiftColor, color, size, fontSize } from 'ui/themes/utils'
import Div from 'ui/elements/Div'
import CIcon from 'ui/components/Icon'

export const Icon = styled(CIcon)`
`

export const AlertBar = styled(Div)`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: ${size('padding', 'sm')};

  ${({ noBorder }) => !noBorder && css`
    border: ${size('borderWidth')} solid ${color('Misc/Divider')};
  `}
  border-radius: ${size('borderRadius')};

  font-size: ${fontSize('md')};

  margin-bottom: ${size('margin', 'md')};
  padding: ${size('padding', 'sm')};

  ${({ type }) => css`
    color: ${shiftColor(type, 80)};
    background-color: ${shiftColor(type, -85)};
    border-color: ${shiftColor(type, -20)};
  `}

  > ${Icon} {
    color: ${(props) => shiftColor(props.type, 20)};
    font-size: ${fontSize('lgplus')};
  }
`
